import { t } from 'i18next';
import React from 'react';
import { Alert, Card } from 'react-bootstrap';
import { capitalizeFirstLetter } from 'utils/helpers';

const HealthRefundCalculation = () => {
  return (
    <Card>
      <Card.Header>
        <h3 className="fs-25 m-0">
          {capitalizeFirstLetter(t('calculation_details.title'))}
        </h3>
      </Card.Header>
      <Card.Body>
        {/* Step 1: Fetch household configuration */}
        <Card className="mb-4">
          <Card.Header>
            {t('calculation_details.step')} 1:{' '}
            {capitalizeFirstLetter(t('calculation_details.step1.title'))}
          </Card.Header>
          <Card.Body>
            <Card.Text>{t('calculation_details.step1.desc')}</Card.Text>
            <ul>
              <li>
                <strong>{t('calculation_details.step1.config1')}</strong>
              </li>
              <li>
                <strong>{t('calculation_details.step1.config2')}</strong>
              </li>
              <li>
                <strong>{t('calculation_details.step1.config3')}</strong>
              </li>
              <li>
                <strong>{t('calculation_details.step1.config4')}</strong>
              </li>
              <li>
                <strong>{t('calculation_details.step1.config5')}</strong>
              </li>
            </ul>
          </Card.Body>
        </Card>

        {/* Step 2: Determine product refundability by refund policy */}
        <Card className="mb-4">
          <Card.Header>
            {t('calculation_details.step')} 2:{' '}
            {capitalizeFirstLetter(t('calculation_details.step2.title'))}
          </Card.Header>
          <Card.Body>
            <Card.Text>{t('calculation_details.step2.desc')}</Card.Text>
            <ul>
              <li>
                <strong>{t('calculation_details.step2.policy1_label')}</strong>
                {' — '}
                {t('calculation_details.step2.policy1_desc')}
              </li>
              <li>
                <strong>{t('calculation_details.step2.policy2_label')}</strong>
                {' — '}
                {t('calculation_details.step2.policy2_desc')}
              </li>
              <li>
                <strong>{t('calculation_details.step2.policy3_label')}</strong>
                {' — '}
                {t('calculation_details.step2.policy3_desc')}
              </li>
              <li>
                <strong>{t('calculation_details.step2.policy4_label')}</strong>
                {' — '}
                {t('calculation_details.step2.policy4_desc')}
              </li>
            </ul>
          </Card.Body>
        </Card>

        {/* Step 3: Calculate net invoice amount */}
        <Card className="mb-4">
          <Card.Header>
            {t('calculation_details.step')} 3:{' '}
            {capitalizeFirstLetter(t('calculation_details.step3.title'))}
          </Card.Header>
          <Card.Body>
            <Card.Text>{t('calculation_details.step3.desc')}</Card.Text>
            <ul>
              <li>{t('calculation_details.step3.rule1')}</li>
              <li>{t('calculation_details.step3.rule2')}</li>
              <li>{t('calculation_details.step3.rule3')}</li>
              <li>{t('calculation_details.step3.rule4')}</li>
            </ul>
            <Alert variant="secondary">
              <code>{t('calculation_details.step3.formula')}</code>
            </Alert>
          </Card.Body>
        </Card>

        {/* Step 4: Apply income-based refund rules */}
        <Card className="mb-4">
          <Card.Header>
            {t('calculation_details.step')} 4:{' '}
            {capitalizeFirstLetter(t('calculation_details.step4.title'))}
          </Card.Header>
          <Card.Body>
            <strong>{t('calculation_details.step4.with_income_title')}</strong>
            <ul className="mt-2">
              <li>{t('calculation_details.step4.with_income_rule1')}</li>
              <li>{t('calculation_details.step4.with_income_rule2')}</li>
              <li>{t('calculation_details.step4.with_income_rule3')}</li>
            </ul>
            <strong>
              {t('calculation_details.step4.without_income_title')}
            </strong>
            <ul className="mt-2">
              <li>{t('calculation_details.step4.without_income_rule1')}</li>
              <li>{t('calculation_details.step4.without_income_rule2')}</li>
            </ul>
          </Card.Body>
        </Card>

        {/* Example */}
        <Card className="mb-4">
          <Card.Header>{t('calculation_details.example.title')}</Card.Header>
          <Card.Body>
            <ul>
              <li>{t('calculation_details.example.val1')}</li>
              <li>{t('calculation_details.example.val2')}</li>
              <li>{t('calculation_details.example.val3')}</li>
              <li>{t('calculation_details.example.val4')}</li>
              <li>{t('calculation_details.example.val5')}</li>
              <li>{t('calculation_details.example.val6')}</li>
              <li>{t('calculation_details.example.val7')}</li>
            </ul>
            <Card.Text>
              <strong>{t('calculation_details.example.calc')}</strong>
              <br />→ {t('calculation_details.example.final')}
            </Card.Text>
          </Card.Body>
        </Card>
      </Card.Body>
    </Card>
  );
};

export default HealthRefundCalculation;
